import { IBankSlipDetail } from './bank-slip.interface';

export interface IPersonInfo {
  id: number;
  name: string;
  email: string;
}

export interface IApproverInfo {
  approved?: boolean;
  createdAt: Date;
  person: IPersonInfo;
}

export enum ETransactionType {
  BANK_SLIP = 'BANK_SLIP',
  BANK_SLIP_IN = 'BANK_SLIP_IN',
  BETWEEN_ACCOUNTS = 'BETWEEN_ACCOUNTS',
  EXTERNAL = 'EXTERNAL',
  PIX_PAYMENT_IN = 'PIX_PAYMENT_IN',
  PIX_REVERSAL_IN = 'PIX_REVERSAL_IN',
  SPB_TRANSFER_IN = 'SPB_TRANSFER_IN',
  MANUAL_PIX_OUT = 'MANUAL_PIX_OUT',
  PAMCARD = 'PAMCARD',
}

export const TransactionTypeTranslations = {
  // Incoming types
  [ETransactionType.EXTERNAL]: 'Transação Externa',
  [ETransactionType.PIX_PAYMENT_IN]: 'PIX',
  [ETransactionType.PIX_REVERSAL_IN]: 'PIX Estornado',
  [ETransactionType.SPB_TRANSFER_IN]: 'Transferência',
  [ETransactionType.BETWEEN_ACCOUNTS]: 'Transferência entre contas',
  [ETransactionType.BANK_SLIP]: 'Boletos e Tributos',
  [ETransactionType.BANK_SLIP_IN]: 'Boletos',
  [ETransactionType.MANUAL_PIX_OUT]: 'Transferência PIX',
  [ETransactionType.PAMCARD]: 'Transferência PIX',
};

export enum ETransactionStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED_APPROVAL = 'REJECTED_APPROVAL',
  PROCESSING = 'PROCESSING',
  CONFIRMED = 'CONFIRMED',
  ERROR = 'ERROR',
  CANCELED = 'CANCELED',
  SENT_TO_PROVIDER = 'SENT_TO_PROVIDER',
  EXPIRED = 'EXPIRED',
}

export const TransactionStatusTranslations = {
  [ETransactionStatus.PENDING_APPROVAL]: 'Pendente',
  [ETransactionStatus.REJECTED_APPROVAL]: 'Rejeitada',
  [ETransactionStatus.PROCESSING]: 'Aprovada',
  [ETransactionStatus.CONFIRMED]: 'Confirmada',
  [ETransactionStatus.ERROR]: 'Erro',
  [ETransactionStatus.CANCELED]: 'Cancelada',
  [ETransactionStatus.SENT_TO_PROVIDER]: 'Enviada',
  [ETransactionStatus.EXPIRED]: 'Expirada',
};

export enum EBalanceType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export interface IQrCode {
  id: number;
  type: 'DYNAMIC' | 'STATIC';
  status: string;
  amount: string;
  emvqrcps: string;
  baasTransactionId: string;
  createdAt: string;
  transactionId: number;
}

export interface ITransaction {
  id: number;
  accountId?: number;
  createdById?: number;
  createdBy?: IPersonInfo | null;
  baasIdentifier?: string;
  endToEndId?: string;
  type: ETransactionType;
  balanceType: EBalanceType;
  status: ETransactionStatus;
  description: string;
  counterpartyName: string;
  counterpartyTaxNumber: string;
  counterpartyBankCode: string;
  counterpartyBankBranch: string;
  counterpartyAccount: string;
  counterpartyPixKey: string;
  value: number;
  resultingBalance: number;
  balanceProcessedAt: string;
  createdAt: string;
  updatedAt?: string;
  transferDate?: string;
  bankSlipDetail?: IBankSlipDetail | null;
  account?: {
    cnpj: string;
    businessName: string;
  };
  /**
   * List of approvers who need to review this transaction
   */
  toReviewEntries?: IApproverInfo[];
  /**
   * List of approvers who already reviewed this transaction
   */
  reviewedEntries?: IApproverInfo[];
  qrcode: IQrCode;
}
